// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","memberGridWarning":"MemberGrid_memberGridWarning__Dv4Gh"};